"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var pickr_js_1 = require("./js/pickr.js");
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPicker.prototype.installed = function () {
        var _this = this;
        var picker = pickr_js_1.default.create({
            el: this.shadowRoot.querySelector('.picker'),
            inline: this.props.inline,
            default: this.props.default,
            useAsButton: !this.props.button,
            swatches: this.props.swatches,
            width: this.props.width,
            components: {
                // Main components
                preview: this.props.preview,
                opacity: this.props.opacity,
                hue: this.props.hue,
                // Input / output Options
                interaction: {
                    hex: this.props.hex,
                    rgba: this.props.rgba,
                    hsla: this.props.hsla,
                    hsva: this.props.hsva,
                    cmyk: this.props.cmyk,
                    input: this.props.input,
                    clear: this.props.clear,
                    save: this.props.save
                }
            },
            strings: this.props.strings
        });
        picker.on('init', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.picker.show();
            _this.fire('init', args[0]);
        }).on('save', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.fire('save', {
                color: args[0].toHEXA().toString(),
                colorObject: args[0]
            });
        }).on('change', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.fire('change', {
                color: args[0].toHEXA().toString(),
                colorObject: args[0]
            });
        }).on('swatchselect', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.fire('swatchselect', {
                color: args[0].toHEXA().toString(),
                colorObject: args[0]
            });
        });
        this.picker = picker;
    };
    ColorPicker.prototype.setColor = function (color) {
        return this.picker.setColor(color);
    };
    ColorPicker.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-color-picker')),
            omi_1.h("div", { class: 'picker' })));
    };
    ColorPicker.css = css;
    ColorPicker.defaultProps = {
        button: true,
        preview: true,
        opacity: true,
        hue: true,
        hex: true,
        rgba: true,
        hsla: true,
        hsva: false,
        input: true,
        clear: true,
        save: true,
        cmyk: false,
        default: '#3365B7',
        swatches: [],
        inline: true,
        strings: {
            save: 'Save',
            clear: 'Clear' // Default for clear button
        }
    };
    ColorPicker.propTypes = {
        button: Boolean,
        preview: Boolean,
        opacity: Boolean,
        hue: Boolean,
        hex: Boolean,
        rgba: Boolean,
        hsla: Boolean,
        hsva: Boolean,
        input: Boolean,
        clear: Boolean,
        save: Boolean,
        cmyk: Boolean,
        default: String,
        swatches: Array,
        inline: Boolean,
        strings: Object,
        width: String
    };
    ColorPicker = __decorate([
        omi_1.tag('m-color-picker')
    ], ColorPicker);
    return ColorPicker;
}(omi_1.WeElement));
exports.default = ColorPicker;
